import { http } from '../../../api/axios';
import { ProductCopyDetails } from '../../../store/api';
import { shopPrefix } from '../../../config';

type Params = {
    productId: string;
    page: number;
    pageSize: number;
    sortBy: string;
    sortDirection: 'ASC' | 'DESC';
};

type ResponseType = { productCopyDetails: ProductCopyDetails[]; totalCount: number };

export async function apiFetchProductCopies({ productId, page, pageSize, sortBy, sortDirection }: Params) {
    return http
        .get<ResponseType>(`${shopPrefix}/v1/products/:productId/copies`, {
            pathParams: { productId },
            params: { page, pageSize, sortBy, sortDirection }
        })
        .then(res => res.data);
}
